<template>
	<div class="main-contents">
		<div class="tit">클라이언트 담당자 승인관리</div>
		<div class="search-box interval">
			<SelectComp class="wd07" list="01:승인,02:미승인,11:반려" v-model="srchFilter.apprYn" title="담당자 승인여부" :isAll="true" /><nbsp/>
			<SelectComp list="corp:클라이언트명,mber:담당자명,hpNo:연락처" v-model="srchFilter.srchDiv" @change="placeholderTxt = $event.target.selectedOptions[0].label" />
			<InputComp v-model="srchFilter.srchTxt" :placeholder="placeholderTxt" @keyup.enter="getAdmDcoPmgMberList('1')"/>
			<img class="search_btn" src="/images/admin/search_btn.png" alt="검색버튼" @click="getAdmDcoPmgMberList('1')"/>
		</div>
		<!-- 전체프로젝트 리스트 -->
		<div class="Board type3 sp">
			<table class="Board_type3 admin">
				<colgroup>
					<col width="4.1%">
					<col width="8%">
					<col width="8%">
					<col width="17%">
					<col width="17%">
					<col width="17%">
					<col width="9%">
					<col width="8%">
					<col width="10%">
				</colgroup> 
				<thead>
					<tr>
						<th>NO</th>
						<th>담당자명</th>
						<th>아이디</th>
						<th>연락처</th>
						<th>기업명</th>
						<th>부서명</th>
						<th>직급</th>
						<th>회원가입일</th>
						<th>관리자 승인</th>
					</tr>
				</thead>
				<tbody>
					<template v-if="dcoPmgList.length > 0">
						<tr v-for="(row, rowIdx) in dcoPmgList" :key="rowIdx" :class="row.mberStatusCd == '02' ? 'new' : ''">
							<!-- <td class="score"><div class="new" v-if="row.mberStatusCd == '02'">new</div>{{rowIdx + 1}}</td> -->
							<td class="score"><div class="new" v-if="row.mberStatusCd == '02'">new</div>{{(pageInfo.pageIndex - 1) * pageInfo.pageUnit + (rowIdx + 1)}}</td>
							<td class="score name" @click="openPopup(row.mberSeq)">{{row.mberNm}} &#9654;</td>
							<td class="score">{{row.loginId}}</td>
							<td class="score">{{row.mberHpNo | phone}}</td>
							<td class="score">{{row.corpNm}}</td>
							<td class="score">{{row.deptNm}}</td>
							<td class="score">{{row.positionNm}}</td>
							<td class="score">{{row.regYmd | date('yyyy.MM.dd')}}</td>
							<td class="score resume">
								<div v-if="row.mberStatusCd == '01'">승인</div>
								<div v-else-if="row.mberStatusCd == '11'" class="reject">반려</div>
								<div v-else class="btn rq"  @click="pmgAppr(rowIdx)">승인하기 &#9654;</div>
							</td>
						</tr>
					</template>
					<template v-else>
						<!-- 관련내용 없을 경우 -->
						<tr>
							<td colspan="9" class="none">등록된 클라이언트 담당 회원이 없습니다.</td>
						</tr>
					</template>
				</tbody>
			</table>
		</div>

		<!-- 페이징부분 -->
		<pagingComp :pageInfo="pageInfo" @page-click="goPage"/>
	</div>
</template>

<script>
import pagingComp from '@/components/PagingComp.vue';

export default {
	data() {
		return {
			srchFilter : {
				apprYn : '',
				srchDiv : 'corp',
				srchTxt : '',
				pageIndex : 1
			},

			pageInfo : {},
			dcoPmgList : [],

			placeholderTxt : '클라이언트명',
		}
	},

	components : {
		pagingComp
	},

	beforeMount() {
		var keys = Object.keys(this.srchFilter);
		for(var key in this.$route.params){
			if(keys.indexOf(key) >= 0){
				this.srchFilter[key] = this.$route.params[key];
			}
		}
	},

	mounted() {
		this.getAdmDcoPmgMberList();
	},

	methods : {
		getAdmDcoPmgMberList(div) {
			var param = this.srchFilter;
			param.pageUnit = '25';
			param.pageSize = '10';
			if(div) param.pageIndex = 1;

			this.$.httpPost('/api/mem/adm/dco/getAdmDcoPmgMberList', param)
				.then(res => {
					//console.log('getAdmDcoPmgMberList RESULT', res);

					this.dcoPmgList = res.data.dcoPmgList;
					this.pageInfo = res.data.pageInfo;
				}).catch(this.$.httpErrorCommon);
		},

		// 클라이언트 담당자 승인하기
		pmgAppr(idx) {
			var obj =  this.dcoPmgList[idx];
			var params = {
				mberNm:obj.mberNm,
				loginId:obj.loginId,
				corpSeq:obj.corpSeq, 
				corpNm:obj.corpNm,
				corpDivCd:'10'
			}

			// this.$.popup('/adm/mem/MEM924P01', {mberNm:obj.mberNm, loginId:obj.loginId, corpNm:obj.corpNm, corpDivCd:'10'})
			this.$.popup('/adm/mem/MEM924P01', params)
				.then(res => {
					if(res) {
						var param = {
							dcoMberSeq : obj.mberSeq,
							mberStatusCd : res.mberStatusCd,
							corpSeq : res.corpSeq
						};

						//console.log('admGmgApproval PARAM', param);
						this.$.httpPost('/api/mem/adm/dco/admGmgApproval', param)
							.then(() => {
								this.getAdmDcoPmgMberList();
							}).catch(this.$.httpErrorCommon);
					}
				})
		},

		// 페이징 이동
		goPage(page) {
			this.srchFilter.pageIndex = page;
			this.getAdmDcoPmgMberList();
		},

		openPopup(seq) {
			var param = {};
			param.reqMberSeq = seq;
			param.div = 'pmg';

			this.$.popup('/adm/mem/MEM923P02', param);
		}
	}
}
</script>